import React from 'react';
import { Button } from '@progress/kendo-react-buttons'
class HistoryPanel extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render() {
        return (
            <>
            <div className="modal-content">
                <div className="modal-header">
                    <span className="modal-title bold" style={{fontSize:"large"}}>
                        <b>Histórico de ações</b>
                    </span>
                    <Button className="remoove k-primary btn-ivdp-secondary btn-theme ml-1 mr-2" onClick={() => this.props.handleHistoryToggle()}>Cancelar</Button>
                </div>
                <div className="modal-body">
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <label className="mb-0"><strong>Detalhes ação</strong></label>
                            <p>#####</p>
                        </div>
                        <div className="col-md-12 my-2">
                            <label className="mb-0"><strong>Detalhes ação</strong></label>
                            <p>#####</p>
                        </div>
                        <div className="col-md-12 my-2">
                            <label className="mb-0"><strong>Detalhes ação</strong></label>
                            <p>#####</p>
                        </div>
                        <div className="col-md-12 my-2">
                            <label className="mb-0"><strong>Detalhes ação</strong></label>
                            <p>#####</p>
                        </div>
                    </div>
                </div>

            </div>
            </>
        )
    }
}
export default HistoryPanel;